import TitleSection from "../components/TitleSection";
import DataPartners from "../components/DataPartners";
import Resources from "../components/Resources";
import data from "../../../datasets/usecases/dataenrichment";
import Recipes from "../components/Recipes";
// import { PricingGetStarted } from "../../Pricing/components/PricingGetStarted";

export const DataEnrichment = () => {
  return (
    <div className="data_enrichment_landing">
      <TitleSection data={data} />
      <Recipes data={data} />
      <DataPartners dataPartners={data.dataPartners} />
      <Resources {...data} />
      {/* <PricingGetStarted /> */}
    </div>
  );
};
